import { createSelector } from 'reselect';
import { minBy } from 'lodash';
import { getUserItemsById, getItemsFactory } from 'state/items/selectors';
import { getAbTestByName } from 'state/ab-tests/selectors';
import { transformItemDtosToProductItems } from 'data/transformers/product-item';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getPushUpCheckout = state => localState(state).pushUpCheckout;
export const getPushUpsAvailability = state => localState(state).pushUpsAvailability;
export const getSelectedIds = state => localState(state).selectedIds;
export const getCurrentPushUpOrder = state => localState(state).pushUpOrder;
export const getPrepareUiState = state => getCurrentPushUpOrder(state).prepareUiState;
export const getFreePushUps = state => getPushUpsAvailability(state).freePushUps;
export const getPushUpOptions = createSelector(getPushUpsAvailability, pushUpsAvailability => {
  return pushUpsAvailability.pushUpOptions.length > 0 ? pushUpsAvailability.pushUpOptions : null;
});
export const getActiveCheckoutModal = state => getPushUpCheckout(state).activeModal;
export const getSelectedItems = getItemsFactory(getSelectedIds, getUserItemsById);
export const getNotOptimizedSelectedItems = createSelector(getSelectedItems, items => transformItemDtosToProductItems(items.filter(item => !('international_shipping_price' in item))));
export const getCheapestPushUpOption = createSelector(getPushUpOptions, pushUpOptions => {
  return minBy(pushUpOptions, pushUpOption => {
    var _pushUpOption$price;

    return ((_pushUpOption$price = pushUpOption.price) === null || _pushUpOption$price === void 0 ? void 0 : _pushUpOption$price.amount) && parseFloat(pushUpOption.price.amount);
  }) || null;
});
export const getDefaultSelectedOption = createSelector(getPushUpOptions, pushUpOptions => {
  if (!pushUpOptions) return null;
  const defaultOption = pushUpOptions.find(option => option.isDefault);
  return defaultOption || pushUpOptions[0];
});
export const getSelectedPushUpOption = state => localState(state).selectedPushUpOption || getDefaultSelectedOption(state);
export const getIsOrderFree = createSelector(getCurrentPushUpOrder, _ref => {
  let {
    order
  } = _ref;
  return order && parseFloat(order.payable.amount) <= 0;
});
export const isOrderConfirmationDisabled = createSelector(getCurrentPushUpOrder, _ref2 => {
  let {
    order
  } = _ref2;
  if (!order) return true;
  return order.isTaxCoverageAvailable === false;
});
export const getHasFreePushUpAvailable = createSelector(getPushUpsAvailability, _ref3 => {
  let {
    freePushUps
  } = _ref3;
  return !!freePushUps.available;
});
export const getHasDiscountedPushUpAvailable = createSelector(getPushUpsAvailability, _ref4 => {
  let {
    pushUpOptions
  } = _ref4;
  return pushUpOptions.some(_ref5 => {
    let {
      discountedPrice
    } = _ref5;
    return discountedPrice;
  });
});
export const getInternationalPushUpsTestVariant = createSelector(getHasFreePushUpAvailable, getHasDiscountedPushUpAvailable, getAbTestByName('international_national_bump'), (hasFreePushUps, hasDiscountedPushUps, abTest) => !abTest || hasFreePushUps || hasDiscountedPushUps ? 'off' : abTest.variant);